table::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

table {
  scrollbar-width: thin;
  scrollbar-color: var(--chart-104-pressed) var(--white-layout-302-level-1-elevation);
}

table::-webkit-scrollbar-track {
  background: var(--white-layout-300-primary);
}

table::-webkit-scrollbar-thumb {
  background-color: var(--chart-104-pressed);
  border-radius: 6px;
}

table thead.hidden {
  height: 0;
  overflow: hidden !important;
}

.is-empty table {
  height: initial;
}

.is-empty table > thead {
  margin-bottom: 5px;
}

[part~='row'].row-is-editable {
  z-index: 99999;
}

[part~='row'] {
  background-color: var(--grid-row-background-color);
}

[part~='cell'] {
  background-color: transparent;
}

[part~='cell'][first-column] {
  padding-left: calc(1.5 * var(--spacer));
}

[part~='cell'][last-frozen] {
  position: sticky;
  right: 0;
}

[part='row']:only-child [part~='header-cell'] {
  height: var(--grid-row-height);
  min-height: var(--grid-row-height);
}

[part='row']:only-child [part~='header-cell']:hover {
  --icon-visibility: visible;
}

[part~='cell'],
[part~='cell']:not([part~='details-cell']),
:host(:not([theme~='no-row-borders'])) [part='row'][first] [part~='cell']:not([part~='details-cell']) {
  min-height: var(--grid-row-height);
}

:host([overflow~='left']) [part~='cell'][last-frozen]:not([part~='details-cell']) {
  border-right-color: var(--checkbox-border-overflow, var(--grid-border-color));
}

[last-frozen]:not([part~='details-cell']) {
  border-right: var(--checkbox-border-overfow-width, 1px) solid transparent;
}

[part~='cell'] ::slotted(vaadin-grid-cell-content) {
  cursor: default;
  padding: 0 var(--spacer);
  text-overflow: initial;
}

[part~='cell'] ::slotted(vaadin-grid-cell-content.gz-select__cell-content),
[part~='cell'] ::slotted(vaadin-grid-cell-content.details-toggle__cell-content) {
  padding: 0;
}

:host(:not([reordering])) [part~='row'].row-is-editable {
  z-index: 2;
}

:host(:not([reordering])) [part~='row'].row-is-editable [part~='cell']:not([part~='details-cell']) {
  height: var(--grid-row-height);
}

[part~='cell'] ::slotted(vaadin-grid-cell-content.details-toggle__cell-content) {
  text-align: center;
}

:host(:not([theme~='no-row-borders'])) [part~='cell']:not([part~='details-cell']) {
  border-bottom: var(--grid-border-width) solid var(--grid-border-color);
  border-top: none;
}

[part~='details-cell'] ::slotted(vaadin-grid-cell-content) {
  padding: var(--spacer) 0;
  z-index: 100;
}

:host [part~='row'] > [part~='header-cell'][reorder-status],
:host [part~='row'] > [part~='header-cell'][reorder-status] ::slotted(vaadin-grid-cell-content) {
  cursor: grab;
}

:host [part~='row'] > [part~='header-cell'][reorder-status='dragging'] {
  cursor: grabbing;
}

:host [part~='row'] > [part~='header-cell'][reorder-status][frozen] {
  cursor: initial;
}

table thead#header [part='row']:hover [part~='cell'][first-column][frozen]{
  background-color: transparent;
}

:host([reordering]) [part~='cell']:not([part~='header-cell']),
:host([reordering]) [part~='cell'][reorder-status='allowed']:not([part~='header-cell']) {
  background: transparent !important;
}

[part~='header-cell'],
:host([overflow~='left']) [part~='row'] [last-frozen]:not([part~=details-cell]),
:host([overflow~='left']) [part~='row'] [part~='cell'][first-column][frozen] {
  background: var(--white-layout-301-level-0-elevation) !important;
}

[part~='header-cell'][reorder-status='dragging'] {
  background: var(--grid-row-reordering-background) !important;
}

[part~='header-cell'][reorder-status='allowed'],
thead#header [part='row']:hover [part~='header-cell'][first-column][frozen]{
  background: var(--white-layout-301-level-0-elevation) !important;
}

:host [part~='row'] > [part~='cell'][reorder-status='dragging']:not([part~='header-cell']) {
  background: var(--chart-104-pressed) !important;
}

[part~='row'][details-opened] {
  border-bottom: var(--grid-border-width) solid var(--grid-border-color);
}

[part~='row']:hover > [part~='body-cell'] {
  background-color: var(--grid-row-hover-background) !important;
}

[part~='row'][selected] > [part~='cell']:not([frozen]){
  --blue-layout-400-primary: var(--blue-layout-405-primary-hc-on-light-background);
}

:host(:not([reordering])) [part~='row'][selected] [part~='body-cell']:not([part~='details-cell']),
:host(:not([reordering])) [part~='row'][highlighted] [part~='body-cell']:not([part~='details-cell']) {
  background-image: none;
  background-color: var(--grid-row-selected-background);
}

/* Compact */
:host([theme~='compact']) {
  --grid-row-height: 32px;
}

:host([theme~='compact']) [part~='cell'],
:host([theme~='compact']) [part='row']:only-child [part~='header-cell'],
:host([theme~='compact']) [part='row'][first] [part~='cell']:not([part~='details-cell']) {
  min-height: var(--grid-row-height) !important;
}

:host([theme~='compact']) [part~='cell'] ::slotted(vaadin-grid-cell-content) {
  padding: 0 var(--spacer);
}

:host([theme~='compact']) [part~='cell'] ::slotted(vaadin-grid-cell-content.gz-select__cell-content),
:host([theme~='compact']) [part~='cell'] ::slotted(vaadin-grid-cell-content.details-toggle__cell-content) {
  padding: 0;
}

:host(.rowCursorPointer) tbody [part~='row']:hover > [part~='body-cell'],
:host(.rowCursorPointer) tbody [part~='row']:hover [part~='cell'] ::slotted(vaadin-grid-cell-content) {
  cursor: pointer;
}

:host(:not([theme~='no-row-borders'])) [part='row']:last-child [part~='header-cell'] {
  border-bottom-color: var(--grid-border-color);
}

:host(:not([theme~='no-row-borders'])) [part='row'][first] [part~='cell']:not([part~='details-cell']).cell-ghost,
tbody [part~='row'] .cell-ghost {
  background-color: var(--grey-layout-chart-100);
}

:host([theme~='row-stripes']) [part~='row']:not([odd]) [part~='body-cell'],
:host([theme~='row-stripes']) [part~='row']:not([odd]) [part~='details-cell'] {
  background-image: none;
  background-color: var(--grid-row-background-color-alternate);
}
